/**
 * Telegram Groups Configuration
 *
 * Default público (fallback final del botón "Unirte Al Grupo"):
 *   https://t.me/juanaperrone
 *
 * Cascada de resolución (DualCTAVideoLanding + VideoTemplate):
 *   1. variant.freeTelegramUrl  (KV — admin variant A/B/C)
 *   2. cfg.free_telegram_url    (DB premium_invite_config)
 *   3. VITE_PREMIUM_SIMPLE_FREE_TELEGRAM_URL  (env)
 *   4. VITE_TELEGRAM_GROUP_URL  (env)
 *   5. DEFAULT_TELEGRAM_GROUP_URL ← este archivo (último recurso)
 *
 * Sirve a todos los idiomas (es, en, pt, fr, de, it, nl) y regiones.
 *
 * Environment Variable (Railway):
 *   VITE_TELEGRAM_GROUP_URL — pisa el default si el admin quiere usar otro
 *                            grupo (público o invite privado).
 */

// Unified Telegram Group for all users
const DEFAULT_TELEGRAM_GROUP_URL = "https://t.me/juanaperrone";

// Main Telegram Group (for all languages)
export const TELEGRAM_GROUP_URL =
  (import.meta.env.VITE_TELEGRAM_GROUP_URL as string) ||
  DEFAULT_TELEGRAM_GROUP_URL;

// Backward compatibility - both point to same group
export const TELEGRAM_GROUP_SPANISH = TELEGRAM_GROUP_URL;
export const TELEGRAM_GROUP_ENGLISH = TELEGRAM_GROUP_URL;

/**
 * Get Telegram group URL based on language/region
 * @param isSpanishSpeaker - Whether the user speaks Spanish (España or LATAM)
 * @returns Telegram group URL (same for all languages now)
 */
export function getTelegramGroupByLanguage(isSpanishSpeaker: boolean): string {
  // Returns same URL for all languages
  return TELEGRAM_GROUP_URL;
}

/**
 * Get Telegram group URL based on region
 * @param region - User's region ("SPAIN", "LATAM", "US", "OTHER")
 * @returns Telegram group URL (same for all regions now)
 */
export function getTelegramGroupByRegion(region: string): string {
  // Returns same URL for all regions
  return TELEGRAM_GROUP_URL;
}

export default {
  TELEGRAM_GROUP_URL,
  TELEGRAM_GROUP_SPANISH,
  TELEGRAM_GROUP_ENGLISH,
  getTelegramGroupByLanguage,
  getTelegramGroupByRegion,
};
